import Splide from "@splidejs/splide";
export default class MediaGallery {
    constructor() {

    }
    init() {
        this.splidePrev    = document.querySelectorAll('.splide--prev');
        this.splideNext    = document.querySelectorAll('.splide--next');

		this.mediaGallery  = document.querySelector('.media-gallery__gallery').getBoundingClientRect();

		if(window.innerWidth <= 767) {
			this.sideSpacing = this.mediaGallery.left - 8;
		} else {
			this.sideSpacing = this.mediaGallery.left - 16;
		}

        let main = new Splide('#main-carousel', {
            type      : 'fade',
            rewind    : true,
            pagination: false,
            arrows    : false,
        });

        let thumbnails = new Splide('#thumbnail-carousel', {
            gap         : 0,
            rewind      : true,
            pagination  : false,
            isNavigation: true,
            arrows      : false,
            type        : 'slide',
			perPage		: 12,
            padding     : {left: this.sideSpacing, right: this.sideSpacing},
            breakpoints : {
                1023: {
                    gap         : 0,
                    padding     : {left: this.sideSpacing, right: this.sideSpacing},
                    type        : 'slide',
					perPage		: 6,
                },
                767: {
                    gap			: 0,
                    type		: 'slide',
                    padding		: 0,
					perPage		: 5,
                },
            },
        } );

        this.splidePrev && this.splidePrev.forEach((splidePrev) => {
            splidePrev.addEventListener('click', (event) => {
                thumbnails.go('-1')
            });
        })

        this.splideNext && this.splideNext.forEach((splideNext) => {
            splideNext.addEventListener('click', (event) => {
                thumbnails.go('+1')
            });
        })

        main.sync(thumbnails);
        main.mount();
        thumbnails.mount();

		// thumbnails.on('resize', function () {
		// 	thumbnails.mount();
		// })
    }
}